import { render, staticRenderFns } from "./image-cropper.vue?vue&type=template&id=4d5b77f8"
import script from "./image-cropper.vue?vue&type=script&lang=ts"
export * from "./image-cropper.vue?vue&type=script&lang=ts"
import style0 from "./image-cropper.vue?vue&type=style&index=0&id=4d5b77f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports